import React, { Suspense } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { EditableEvent } from 'types/event.types';
import LoadingSpinner from 'components/common/loaders/LoadingSpinner';
import { eventEditorQueryKeys } from '@event-editor/queryKeys';

import { getEvent } from './api/get-event';

export const EventEditorContext = React.createContext<EditableEvent | undefined>(undefined);

export const EventEditorProvider = ({
  children
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const { id } = useParams();
  const dashboardEventQuery = useSuspenseQuery({
    queryKey: eventEditorQueryKeys.event(Number(id)),
    queryFn: () => getEvent(Number(id))
  });
  return (
    <Suspense fallback={<LoadingSpinner data-testid="loadingSpinner" fullscreen />}>
      <EventEditorContext.Provider value={dashboardEventQuery.data.event}>
        {children}
      </EventEditorContext.Provider>
    </Suspense>
  );
};
